module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-nav-layer-picker"
  }, [(_vm.type === 'cue') ? _c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Active Cue Layer")]) : _c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Active Note Layer")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-wrapper"
  }, [_c('div', {
    staticClass: "dropdown-trigger",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "color-box",
    style: ({
      backgroundColor: _vm.selectedLayer.color
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "layer-title"
  }, [_vm._v(_vm._s(_vm.selectedLayer.title || 'Select an active layer'))])]), _vm._v(" "), (_vm.dropdownOpen) ? _c('div', {
    staticClass: "custom-dropdown"
  }, _vm._l((_vm.validLayers), function(layer) {
    return _c('div', {
      key: layer.id,
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          return _vm.selectLayer(layer)
        }
      }
    }, [_c('span', {
      staticClass: "color-box",
      style: ({
        backgroundColor: layer.color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "layer-title"
    }, [_vm._v(_vm._s(layer.title))])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7656bf2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/layer-picker.vue
// module id = 1264
// module chunks = 21